<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card rounded="lg" elevation="1">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <div class="title text-center">Total ventas</div>
                <div class="title font-weight-bold text-center">
                  <!-- {{ totalVentas }} € -->
                  234€
                </div>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="3">
                <div class="title text-center">Total pedidos</div>
                <div class="title font-weight-bold text-center">
                  <!-- {{ totalNumPedidos }} -->
                  56
                </div>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="3">
                <!--  v-if="!!$store.state.zcierre" -->
                <div class="title text-center">Hora inicio</div>
                <div class="title font-weight-bold text-center">
                  <!-- {{ inicioMostrar }} -->
                  08:30h
                </div>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" md="3">
                <!--  v-if="!!$store.state.zcierre" -->
                <div class="title text-center">Hora cierre</div>
                <div class="title font-weight-bold text-center">
                  <!-- {{ finMostrar }} -->
                  23:45h
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row id="graficos-donuts">
<!--      <v-col cols="12" md="6">
        <v-card rounded="lg" elevation="1">
          <v-card-title class="grey--text text--darken-2"
            >Pedidos/Mesas</v-card-title
          >
          <v-card-text>
            <formas-pago-donut
              :chart-data="pedidosModosDonut"
              id="grafico-modos"
            />
          </v-card-text>
        </v-card>
      </v-col>
       <v-col cols="12" md="6" v-if="pedidosFormasPagoDonut">
        <v-card rounded="lg" elevation="1">
          <v-card-title class="grey--text text--darken-2"
            >Formas de pago</v-card-title
          >
          <v-card-text>
            <formas-pago-donut :chart-data="pedidosFormasPagoDonut" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card rounded="lg" elevation="1">
          <v-card-title class="grey--text text--darken-2"
            >Productos más vendidos</v-card-title
          >
          <v-card-text>
            <categorias-productos-area :chart-data="productosArea" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card rounded="lg" elevation="1">
          <v-card-title class="grey--text text--darken-2"
            >Categorías más vendidas</v-card-title
          >
          <v-card-text>
            <categorias-productos-area
              id="grafico-categorias"
              :chart-data="categoriasArea"
              :options="{
                responsive: true,
                maintainAspectRatio: false,
              }"
            />
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
<!--     <v-row>
      <v-col cols="12">
        <v-card rounded="lg" elevation="1">
          <v-card-title class="grey--text text--darken-2"
            >Ventas por horas</v-card-title
          >
          <v-card-text>
            <pedidos-horas-barras
              id="grafico-pedidos-horas"
              :chartData="pedidosHorasBarrasDatos"
              :options="pedidosHorasBarrasOpciones"
              style="height: 300px"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import FormasPagoDonut from "@/components/graficos/FormasPagoDonut";
export default {
  props: {
    datos: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tipoMostrar: "cobrados",
      ChartsBgColors: [
        "#00f4d9aa",
        "#fb8c00aa",
        "rgba(255, 206, 86, 0.6)",
        "rgba(255, 99, 132, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(153, 102, 255, 0.6)",
        "rgba(255, 159, 64, 0.6)",
        "rgba(54, 206, 0, 0.6)",
      ],
      ChartsBorderColors: [
        "#00f4d9",
        "#fb8c00",
        "rgba(255, 206, 86, 1)",
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
        "rgba(54, 206, 0, 1)",
      ],
    }
  },
  components: {
    FormasPagoDonut,
  },
  computed: {
    pedidosModosDonut() {
      if (this.resumenCierre[this.tipoMostrar]) {
        var backgroundColor = this.ChartsBgColors;
        var borderColor = this.ChartsBorderColors;

        return {
          labels: this.resumenCierre[this.tipoMostrar].modos.map(
            (m) => m.nombre
          ),
          datasets: [
            {
              backgroundColor: backgroundColor,
              borderColor: borderColor,
              data: this.resumenCierre[this.tipoMostrar].modos.map((h) =>
                h.total
              ),
            },
          ],
        };
      }
    },
    resumenCierre() {
      return this.$store.state.zcierreResumen;
    },
  },
};
</script>

<style>
</style>